import dynamic from 'next/dynamic';
import withMetatags from 'core/hocs/withMetatags';

const AboutUsDellowo = dynamic(() => import('./AboutUsPremiumStation'), { ssr: true });

export default withMetatags(AboutUsDellowo, { withCanonicalUrl: true });
